<template>
    <div class="share-wechat-layer-wrapper">
        <a href="javascript:;" class="share-wechat-tip" @click="showTipLayer">
            <span>分享到朋友圈</span>
            <span class="push-dot"></span>
        </a>
        <div class="share-wechat-layer" style="display: none;">
            <div class="share-guide"></div>
            <div class="share-slogan"></div>
        </div>
    </div>
</template>

<script>
    import ShareWechat from '../_utils/share-wechat';
    import SohuStat from '../statistics/sohu-stat';
    export default {
        data() {
            return {
                isFirstClick: true
            }
        },
        methods: {
            showTipLayer () {
                SohuStat.sendActionStat('20012');
                var $shareWechatLayer = $('.share-wechat-layer');
                if(this.isFirstClick) {
                    this.isFirstClick = false;
                    $shareWechatLayer.remove();
                    $('body').append($shareWechatLayer);
                    $shareWechatLayer.on('click', function() {
                        $shareWechatLayer.hide().css({
                            opacity: 0
                        });
                    });
                }
                $shareWechatLayer.show()
                // 延迟10ms使得动画渐变的效果可以执行。
                setTimeout(function() {
                    $shareWechatLayer.css({
                        opacity: 1
                    });
                }, 10);
            }
        },
        mounted() {
            var shareImage = document.querySelector('#articleContent img.content-image');
            var shareImageSrc = shareImage && shareImage.getAttribute('src');
            if(/^\/\//.test(shareImageSrc)) {
                shareImageSrc = 'http:' + shareImageSrc;
            }
            var shareData = {
                title: document.title,
                desc: document.querySelector('meta[name="description"]').getAttribute('content') || '',
                link: window.location.href,
                imgUrl: shareImageSrc || 'http://s8.rr.itc.cn/org/wapChange/20161_5_11/b8v0r29602064149596.jpg'
            };
            ShareWechat(shareData);
        }
    }
</script>

<style lang="less" rel="stylesheet/less">
    .share-wechat-layer-wrapper {
        .share-wechat-tip {
            position: relative;
            padding-right: 26px;
            line-height: 88px;
            font-size: 30px;
            .push-dot {
                position: absolute;
                right: -16px;
                top: -16px;
                width: 16px;
                height: 16px;
                border-radius: 50%;
                background: red;
            }
        }
    }
    .share-wechat-layer {
        position: fixed;
        left: 0;
        top: 0;
        z-index: 1000;
        display: none;
        width: 100%;
        height: 100%;
        background: rgba(25, 25, 25, 0.9);
        opacity: 0;
        transition: opacity .5s;
        .share-guide {
            position: absolute;
            right: 50px;
            top: 20px;
            width: 378px;
            height: 222px;
            background: url(../less/images/share/share-guide.png) no-repeat 0 0;
            background-size: 100% 100%;
        }
        .share-slogan {
            position: absolute;
            top: 40%;
            left: 50%;
            width: 425px;
            height: 96px;
            margin-left: -210px;
            background: url(../less/images/share/share-slogan.png) no-repeat 0 0;
            background-size: 100% 100%;
        }
    }
</style>